import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "expiring-plans-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_4 = {
  key: 1,
  class: "plans-grid"
}
const _hoisted_5 = { class: "plan-header" }
const _hoisted_6 = { class: "plan-title" }
const _hoisted_7 = { class: "plan-details" }
const _hoisted_8 = { class: "plan-actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "no-plans"
}
const _hoisted_12 = {
  key: 3,
  class: "modal-overlay"
}
const _hoisted_13 = { class: "modal-container" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "error-message"
}
const _hoisted_16 = {
  key: 2,
  class: "loader-container"
}
const _hoisted_17 = {
  key: 3,
  class: "button-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeIcon = _resolveComponent("HomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeIcon, {
      showArrow: true,
      to: "adm-dashboard"
    }),
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "title" }, "Planos Próximos ao Vencimento", -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "loader" }, null, -1),
            _createElementVNode("p", null, "Carregando planos...", -1)
          ])))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.expiringPlans.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiringPlans, (plan) => {
              return (_openBlock(), _createElementBlock("div", {
                key: plan.id,
                class: "plan-card"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(plan.usuario.nome), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Início:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(plan.dataInicio)), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Término:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(plan.dataFim)), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Faltam:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.calculateDaysLeft(plan.dataFim)) + " dias", 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Quadra:", -1)),
                    _createTextVNode(" " + _toDisplayString(plan.quadra.nome), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Horários:", -1)),
                    _createTextVNode(" " + _toDisplayString(plan.horarios), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Dia:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDayOfWeek(plan.indexDia)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "action-button notify",
                    onClick: ($event: any) => (_ctx.openWhatsApp(plan.usuario.telefone, plan.usuario.nome))
                  }, " Avisar no WhatsApp ", 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "action-button renew",
                    onClick: ($event: any) => (_ctx.showRenewModal(plan.id))
                  }, " Renovar ", 8, _hoisted_10)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.expiringPlans.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[9] || (_cache[9] = [
            _createElementVNode("p", null, "Nenhum plano expira nos próximos 5 dias.", -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Atenção!", -1)),
              (!_ctx.renewing)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Você está prestes a renovar este plano. A data de término será atualizada. Deseja continuar? "))
                : _createCommentVNode("", true),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.renewing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[10] || (_cache[10] = [
                    _createElementVNode("div", { class: "loader" }, null, -1),
                    _createElementVNode("p", null, "Renovando...", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "modal-button cancel",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "modal-button confirm",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmRenew()))
                    }, "Confirmar")
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}